import { type ListenerMiddleware } from '@reduxjs/toolkit';
import type { ReduxAjaxParams } from '@chipp972/redux-ajax';

import { type ConfigState } from '../configSlice';

interface SetCredentialsOnReduxRequestAction {
  type: string;
  data: ReduxAjaxParams;
}

export const setCredentialsOnReduxRequest: ListenerMiddleware<{
  configuration: ConfigState;
}> = store => next => action => {
  const typedAction = action as SetCredentialsOnReduxRequestAction;

  if (typedAction.type === 'AJAX_REQUEST_SET_REQUEST_PARAMS') {
    const config = store.getState().configuration.config;

    typedAction.data.credentials = typedAction.data.url?.includes(config.services.ICARE_BACK.url) ? 'include' : 'same-origin';
  }
  next(action);
};
